<template>
    <div class="test_complete">
        <div class="test_complete_title">
            ¡Has completado el examen!
        </div>
        <div class="test_complete_description">
            Al presionar el botón continuar, podrás programar tu asesoría con uno de nuestros docentes especializados.
        </div>
        <div class="test_complete_image">
            <img src="@/assets/images/evaluation/complete.svg" />
        </div>
        <div class="test_complete_footer">
            <v-btn
                color="primary"
                class="uppercase"
                @click="nextStep"
                >
                Continuar
            </v-btn>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        nextStep(){
            this.$emit('nextStep',2);
            this.$router.push({ path: `/evaluation/schedule` });
        }
    },
}
</script>